import { combineEpics } from 'redux-observable';

import playerEventsEpics from './player/epics';
import playerStateEpics from './player/state/epics';
import playerVideoSourceEpics from './player/videoSource/epics';
import playerCDNTokenSourceEpics from './player/cdnToken/epics';
import uiEpics from './ui/epics';
import uiCaptionsEpics from './ui/captions/epics';
import trackingEpics from './tracking/epics';
import freewheelEpics from './ads/freewheel/epics';
import auditudeEpics from './ads/auditude/epics';


export default combineEpics(
	playerEventsEpics,
	playerStateEpics,
	playerVideoSourceEpics,
	playerCDNTokenSourceEpics,
	uiEpics,
	uiCaptionsEpics,
	trackingEpics,
	freewheelEpics,
	auditudeEpics,
);



// WEBPACK FOOTER //
// ./src/epics.js